export default __webpack_public_path__ + "static/media/img_declaration_benefit1.040ce3c7.svg";